import { MatPaginatorIntl } from '@angular/material/paginator';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

export class PaginatorI18n {

  constructor(
    private readonly translate: TranslateService,
    readonly fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  getPaginatorIntl(): MatPaginatorIntl {
    const paginatorIntl = new MatPaginatorIntl();
    paginatorIntl.itemsPerPageLabel = this.translate.instant('DATATABLE.ITEMS_PER_PAGE');
    paginatorIntl.nextPageLabel = this.translate.instant('DATATABLE.NEXT_PAGE');
    paginatorIntl.previousPageLabel = this.translate.instant('DATATABLE.PREVIOUS_PAGE');
    paginatorIntl.firstPageLabel = this.translate.instant('DATATABLE.FIRST_PAGE');
    paginatorIntl.lastPageLabel = this.translate.instant('DATATABLE.LAST_PAGE');
    paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);
    return paginatorIntl;
  }

  private getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return this.translate.instant('DATATABLE.RANGE_PAGE_1', { length });
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return this.translate.instant('DATATABLE.RANGE_PAGE_2', { startIndex: startIndex + 1, endIndex, length });
  }
}
